// src/components/dashboard/wall/day6/index.jsx (your Day6 parent)
import { useEffect, useRef, useState } from "react";
import PenaltyComponent from "./components/penaltyComponent";
import CyberBoxComponent from "../../../shared/ui/layout/CyberBoxComponent";
import { SparklesCore } from "../../../shared/animations/sparkles/soarklesCore";
import WinnerComponent from "./components/winnerComponent";

export function Day6() {
  const [showWinner, setShowWinner] = useState(false);
  const [winnerKey, setWinnerKey] = useState(null);

  // Listen to both CustomEvent and BroadcastChannel (panel emits both)
  useEffect(() => {
    const onCustom = (e) => {
      const { type } = e; // actionId
      const payload = e.detail || {};
      if (type === "DAY6_SHOW_WINNER") {
        setWinnerKey(payload.winner);
        setShowWinner(true);
      } else if (
        type === "DAY6_HIDE_WINNER" ||
        type === "DAY6_RESET" ||
        type === "DAY6_SHOW_PANEL"
      ) {
        setShowWinner(false);
        setWinnerKey(null);
      }
    };

    const wrap = (msg) => {
      const { actionId, payload } = msg?.data || {};
      if (actionId === "DAY6_SHOW_WINNER") {
        setWinnerKey(payload?.winner);
        setShowWinner(true);
      } else if (
        actionId === "DAY6_HIDE_WINNER" ||
        actionId === "DAY6_RESET" ||
        actionId === "DAY6_SHOW_PANEL"
      ) {
        setShowWinner(false);
        setWinnerKey(null);
      }
    };

    window.addEventListener("DAY6_SHOW_WINNER", onCustom);
    window.addEventListener("DAY6_HIDE_WINNER", onCustom);
    window.addEventListener("DAY6_RESET", onCustom);
    window.addEventListener("DAY6_SHOW_PANEL", onCustom);

    let bc;
    try {
      bc = new BroadcastChannel("operator-events");
      bc.onmessage = wrap;
    } catch {}

    return () => {
      window.removeEventListener("DAY6_SHOW_WINNER", onCustom);
      window.removeEventListener("DAY6_HIDE_WINNER", onCustom);
      window.removeEventListener("DAY6_RESET", onCustom);
      window.removeEventListener("DAY6_SHOW_PANEL", onCustom);
      if (bc) bc.close();
    };
  }, []);

  return (
    <CyberBoxComponent>
      <SparklesCore
        id="tsparticlesfullpage"
        background="transparent"
        minSize={0.6}
        maxSize={1.4}
        particleDensity={30}
        className="w-full h-full absolute top-[0] left-[50%] translate-x-[-50%]  overflow-hidden "
        particleColor="#E8232C"
      />

      {showWinner && winnerKey ? (
        <WinnerComponent teamKey={winnerKey} />
      ) : (
        <PenaltyComponent />
      )}
    </CyberBoxComponent>
  );
}
export default Day6;
